import React, { useEffect, useState } from "react";
import IndentInsertion from "./IndentInsertion";
import axios from "axios";
import IndentUpdate from "./IndentUpdate";
import IndentReport from "./IndentReport";
import ClsLoadingMaster from "../ClsLoading/ClsLoadingMaster";
import ClsUnloadingInsMaster from "../ClsUnloading/ClsUnloadingInsMaster";

const CLSIndentMaster = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [active, setActive] = useState("insert");
  const [siding, setSiding] = useState([]);
  const [rakeType, setRaketype] = useState([]);
  const [commodity, setCommodity] = useState([]);

  const fetchData1 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}allMasterData?table_name=m_wagons`,
      );
      if (response.data.success === true) {
        setRaketype(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  const fetchData2 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}allMasterData?table_name=m_stations_sidings_useable`,
      );
      if (response.data.success === true) {
        setSiding(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  const a = [
    ...new Set(
      siding?.filter((o) => o?.zone === "WC")?.map((o) => o?.sdng_list),
    ),
  ];
  const fetchData3 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}allMasterData?table_name=m_commodity`,
      );
      if (response.data.success === true) {
        setCommodity(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData1();
    fetchData2();
    fetchData3();
  }, []);

  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <div className="row m-5">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("insert");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "insert" && "active"
            }`}
          >
            Indent
          </button>
          <button
            onClick={() => {
              setActive("update");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "update" && "active"
            }`}
          >
            Update Indent
          </button>
          <button
            onClick={() => {
              setActive("Loading");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "Loading" && "active"
            }`}
          >
            Loading
          </button>{" "}
          <button
            onClick={() => {
              setActive("Unloading");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "Unloading" && "active"
            }`}
          >
            Unloading
          </button>
          <hr />
        </div>
      </div>
      {/* <div>
        <IndentInsertion
          siding={[
            ...new Set(
              siding
                .filter((o) => o.zone === "WC" && o.dvsn === "JBP")
                .map((o) => o.sdng_list),
            ),
          ]}
          rakeType={[...new Set(rakeType.map((o) => o.rake_typ))]}
          commodity={[...new Set(commodity.map((o) => o.group_rake_commodity))]}
        />
      </div>
      <div>
        <IndentReport />
      </div>
      <div>
        <IndentUpdate />
      </div> */}
      <div className="row">
        {active === "insert" ? (
          <div className="">
            <IndentInsertion
              siding={[
                ...new Set(
                  siding
                    .filter(
                      (o) => o.G_and_S_flag === "G" || o.G_and_S_flag === "S",
                    )
                    .map((o) => o.sdng_goods_list),
                ),
              ]}
              destination={[...new Set(siding.map((o) => o.station_code))]}
              rakeType={[...new Set(rakeType.map((o) => o.rake_typ))]}
              commodity={[...new Set(commodity.map((o) => o.rake_commodity))]}
            />
          </div>
        ) : active === "update" ? (
          <div>
            <IndentUpdate
              siding={[
                ...new Set(
                  siding
                    .filter(
                      (o) => o.G_and_S_flag === "G" || o.G_and_S_flag === "S",
                    )
                    .map((o) => o.sdng_goods_list),
                ),
              ]}
              destination={[...new Set(siding.map((o) => o.station_code))]}
              rakeType={[...new Set(rakeType.map((o) => o.rake_typ))]}
              commodity={[...new Set(commodity.map((o) => o.rake_commodity))]}
            />
          </div>
        ) : active === "Unloading" ? (
          <div>
            <ClsUnloadingInsMaster />
          </div>
        ) : (
          <ClsLoadingMaster />
        )}
      </div>
    </div>
  );
};
export default CLSIndentMaster;
